<template>
  <div>
    <div class="row center align-items-center">
      <div class="col">
        <h1 class="mb-4">
          {{ $t('pages.complete.title') }}
        </h1>
        <h4>{{ $t('pages.complete.thank_you_for_submitting') }}</h4>
        <h6 class="">{{ $t('pages.complete.data_submitted') }}</h6>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SymptomsPage',
  data() {
    return {
      uuid: localStorage.getItem('uuid'),
      loading: false,
      error: false,
      tag: '',
      symptoms: [],
    };
  },
  created() {
    localStorage.removeItem('uuid');

  }
}
</script>
